const userCentricsScript = document.createElement('script');
userCentricsScript.setAttribute('src', process.env.VUE_APP_USERCENTRICS_URL);
userCentricsScript.setAttribute('id', process.env.VUE_APP_USERCENTRICS_ID);
document.head.appendChild(userCentricsScript);
